export default "__VITE_ASSET__137bb2b2__"